
export default class RHService 
{
    constructor(http) {
        this.http = http
    }

    async todayBirthdays()
    {
        const endpoint = '/birthdays'
        const { data } = await this.http.get(endpoint)       

        const birthdays = data.list.map( item => {           
            return {
                title: item.name,                
                cover_image:{
                    src: item.photo_url || require('../assets/images/no-image.png')
                },
                info: item.birthdate,
                department: item.department,
                url: '#'
            }
        })
        
        return birthdays
    }
}